import { BasePreAuthenticationConfig } from '@/services/auth/call-with-auth/base'
import { InvalidAuthenticationStateError } from '@/services/auth/validate-auth'

export class PreValidateAuth extends BasePreAuthenticationConfig {
  readonly id: string = 'validate auth'

  processable(): boolean {
    return this.authStateStore.hasAccessToken() && !this.authStateStore.hasValidatedAuth()
  }

  cascadeOn(error: unknown): boolean {
    return error instanceof InvalidAuthenticationStateError
  }

  process(): Promise<void> {
    return this.authGateway.validateAuth().then(result => result.fold(
      this.throwOnFail('fail to validate auth'),
      this.onSuccess('success to validate auth')
    ))
  }
}
